// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1_s5-","additionalInfo":"AgreementModal_additionalInfo__1BF65"};